<template>
<div class="home container">
  <!-- 侧边栏小助手 -->
  <assistantSide></assistantSide>
  <div class="content-top">
    <div class="entry-list" wzades="提供跨省通办、省内通办、全市通办等专栏服务入口" aria-label="提供跨省通办、省内通办、全市通办等专栏服务入口">
      <div class="content-title">跨域通办专栏服务入口</div>
      <div class="entry-list-content">
        <a class="item" v-for="(item, i) in entryList" :key="i" :href="`${BASE_URL}zhanjiangGeneralOffice.html#/index?nav=${item.index}`">
          <div class="item-title">{{ item.title }}</div>
          <div>
            查看{{ item.title }}事项
            <i class="el-icon-right"></i>
          </div>
        </a>
      </div>
    </div>
    <div class="search-box" wzades="填写您的办事场景，可帮您搜索办事大厅或者查到事项" aria-label="填写您的办事场景，可帮您搜索办事大厅或者查到事项">
      <div class="content-title">智能搜索，快速定位</div>
      <div class="search-box-content">
        <div class="search-box-title">填写办事场景</div>
        <div class="search-tips">
          <i class="el-icon-warning-outline"></i>
          下列可选择的城市，即已开通通办服务，若没找到对应城市，即暂未开通通办服务。
        </div>
        <el-form ref="form" :model="searchObj" label-width="210px" label-position="right">
          <el-form-item label="您当前所在地？" required>
            <el-cascader :append-to-body="false" v-model="searchObj.szdArea" :options="gdzjCityList" @change="handleChange" style="width: 100%"></el-cascader>
          </el-form-item>
          <el-form-item label="您要办理哪个城市的事项？" required>
            <el-cascader :append-to-body="false" v-model="searchObj.handledArea" :options="gdzjCityList" @change="handleChange" style="width: 100%"></el-cascader>
          </el-form-item>
          <el-form-item label="您要办理什么事项？">
            <el-input v-model="searchObj.approveItem"></el-input>
          </el-form-item>
        </el-form>
        <div class="btn-line">
          <button class="common-btn md-btn search-btn" @click="searchItem()">按事项查询</button>
        </div>
      </div>
    </div>
  </div>
  <div class="content-mid" wzades="提供按大厅名称、按事项等方式搜索大厅地址" aria-label="提供按大厅名称、按事项等方式搜索大厅地址">
    <div class="content-title">跨域通办政务服务地图</div>
    <div class="hall-map-content">
      <div class="hall-content">
        <p class="hall-title">按大厅搜索</p>
        <el-input class="hall-input" v-model="hallName" @keyup.enter.native="_getCrossHallInfoList()" placeholder="可输入大厅、窗口、地址名称关键词" clearable>
          <template slot="append">
            <a href="javascript://" @click="_getCrossHallInfoList()"><i class="el-icon-search" style="margin-right:5px;"></i>搜周边</a>
          </template>
        </el-input>
        <div class="hall-list">
          <div class="hall-item" v-for="(item, i) in hallList" :key="i">
            <div class="hall-name"><i class="hall-index-icon">{{ i + 1 }}</i> {{ item.hallName }}</div>
            <div class="hall-item-detail flex-row">
              <img :src="telIcon" class="hall-img" alt="大厅电话">
              <div>{{ item.telPhone }}</div>
            </div>
            <div class="hall-item-detail flex-row">
              <img :src="timeIcon" class="hall-img" alt="时间">
              <div>{{ item.workTime }}</div>
            </div>
            <div class="hall-item-detail flex-row">
              <img :src="addressIcon" class="hall-img" alt="大厅地址">
              <div>{{ item.address }}</div>
            </div>
            <button class="hall-item-btn" @click="changeCenter(item)">去这里 <i class="el-icon-right"></i></button>
          </div>
        </div>
      </div>
      <div class="map-content" id="mapContainer"></div>
    </div>
  </div>
</div>
</template>

<script>
import assistantSide from '../components/assistantSide.vue'
import {
  getCityByNet,
  getCrossHallInfoList
} from '@/assets/utils/controlApi.js'
import {
  gdzjCityList
} from '@/assets/utils/areaJson.js'
import TMap from '../mixins/TMap.js'
export default {
  data() {
    return {
      BASE_URL: process.env.BASE_URL,
      gdzjCityList: gdzjCityList,
      entryList: [{
        title: "跨省通办",
        index: 1,
        url: ""
      }, {
        title: "省内通办",
        index: 2,
        url: ""
      }, {
        title: "全市通办",
        index: 3,
        url: ""
      }],
      searchObj: {
        szdArea: [],
        handledArea: ["gd", window.gdzjAreaCode],
        approveItem: ""
      },
      hallList: [],
      hallName: ""
    }
  },
  mixins: [TMap],
  components: {
    assistantSide
  },
  methods: {
    handleChange(e) {
      console.log(e, this.searchObj.handledArea)
    },
    /* 按事项查询
     * 1、当“所在地”为湛江市时，“办理的事项地区”为湛江市时，则为全市通办。
     * 2、当“所在地”为湛江市时，“办理的事项地区”为非湛江市，需要判断“办理的事项地区”是否为广东省内地区；如果为广东省内地区，则为省内通办，如果为非广东省内地区，则为跨省通办。
     * 3、当“所在地”为非湛江市时，需要判断“所在地”是否为广东省内地区；如果为广东省内地区，则为省内通办，如果为非广东省内地区，则为跨省通办。
     */
    searchItem() {
      console.log("--点击按钮--", this.searchObj)
      if (this.searchObj.szdArea.length == 0) {
        this.$message.error("请选择所在地！");
        return;
      } else if (this.searchObj.handledArea.length == 0) {
        this.$message.error("请选择您要办理哪个城市的事项！");
        return;
      }
      let nav = "";
      let activeIndex = ""; //回显选中对应的tabs
      if (this.searchObj.szdArea[1] == window.gdzjAreaCode) {
        // 当“所在地”为湛江市时
        if (this.searchObj.handledArea[0] == "gd") {
          if (this.searchObj.handledArea[1] == window.gdzjAreaCode) {
            //“办理的事项地区”为湛江市时，则为全市通办
            nav = 3;
          } else {
            // “办理的事项地区”为广东省内地区，则为省内通办
            nav = 2;
            activeIndex = "2";
          }
        } else {
          // “办理的事项地区”为非广东省内地区，则为跨省通办
          nav = 1;
          activeIndex = "2";
        }
      } else if (this.searchObj.szdArea[0] == "gd") {
        // “办理的事项地区”为广东省内地区，则为省内通办
        if (this.searchObj.handledArea[1] == window.gdzjAreaCode) {
          nav = 2;
          activeIndex = "1";
        }
      } else {
        if (this.searchObj.handledArea[1] == window.gdzjAreaCode) {
          // “办理的事项地区”为非广东省内地区，则为跨省通办
          nav = 1;
          activeIndex = "1";
        }
      }
      if (!nav) {
        this.$message.error("无该地区通办事项");
        return;
      }
      sessionStorage.setItem("scopeDivisionsObj", JSON.stringify({
        activeIndex: activeIndex,
        ...this.searchObj
      }));
      this.$router.push({
        path: "/index",
        query: {
          nav: nav
        }
      })
    },
    // 根据ip获取当前所在地区
    _getCityByNet() {
      getCityByNet().then(res => {
        let obj = res.split("=")[1];
        obj = JSON.parse(obj.slice(0, obj.length - 1));
        // IP判断后，如果找不到对应城市就不帮用户默认选择
        let flag = false; //是否存在json里面
        let firstLevel = "";
        this.gdzjCityList.forEach(item => {
          let index = item.children.findIndex(ele => ele.value == obj.cid);
          if (index > -1) {
            firstLevel = item.value;
            flag = true;
            return;
          }
        });
        if (flag) {
          this.searchObj.szdArea = [firstLevel, obj.cid];
        }
      })
    },
    // 获取跨域通办事项大厅列表
    _getCrossHallInfoList() {
      return new Promise(resolve => {
        getCrossHallInfoList({
          hallName: this.hallName,
          pageIndex: 1,
          pageRowNum: 9999,
          auditType: 'internal'
        }).then(res => {
          if (res.status == '200') {
            let hallList = res.data.dataList
            hallList.forEach((item, i) => {
              item.num = i + 1
            })
            this.hallList = hallList
          } else {
            this.$message({
              message: res.desc,
              type: 'warning'
            });
          }
          resolve()
        })
      })
    },
  },
  async mounted() {
    this._getCityByNet()
    await this._getCrossHallInfoList();
    console.log("--hallList--", this.hallList)
    this.initMap();
  }
}
</script>

<style lang="scss">
.home {
  padding-top: 70px;

  .content-title {
    font-size: 28px;
    font-weight: 600;
    color: #3E97DF;
    line-height: 40px;
    margin-bottom: 20px;
  }

  .entry-list {
    width: 372px;
    display: inline-block;
    vertical-align: top;

    .entry-list-content {
      border-right: 1px dashed #E1E3E4;

      .item {
        display: inline-block;
        padding: 30px;
        width: 282px;
        background: #FAFDFF;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.07);
        font-size: 16px;
        color: #45484B;
        line-height: 22px;

        .item-title {
          font-weight: 500;
          color: #0D1C28;
          line-height: 28px;
          font-size: 20px;
          margin-bottom: 8px;
        }

        &+.item {
          margin-top: 20px;
        }
      }
    }
  }

  .search-box {
    margin-left: 30px;
    display: inline-block;
    vertical-align: top;
    width: 797px;

    .search-box-content {
      height: 345px;
      background: rgba(62, 151, 223, 0.06);
      padding: 20px 30px 30px;
      font-size: 16px;
      line-height: 21px;
    }

    .search-box-title {
      font-size: 20px;
      color: #0D1C28;
      line-height: 28px;
      font-weight: 500;
      margin-bottom: 10px;
    }

    .search-tips {
      color: #727475;
      margin-bottom: 20px;
    }

    .btn-line {
      padding-left: 210px;
    }

    .search-btn {
      width: 248px;
      background: rgba(60, 145, 225, 0.1);
      padding: 13px 0;
    }

  }

  .content-mid {
    margin-top: 58px;

    .hall-map-content {
      background: #FFFFFF;
      box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      padding: 30px;
    }

    .hall-content {
      width: calc(100% - 776px);
      display: inline-block;
      vertical-align: top;

      .hall-title {
        font-size: 24px;
        font-weight: 500;
        color: #0D1C28;
        line-height: 34px;
      }

      .hall-input {
        margin-top: 12px;

        .el-input__inner {
          padding-left: 10px;
          padding-right: 7px;
          border-right: 0;
          border-color: #DDDDDD;
        }

        .el-input.is-active .el-input__inner,
        .el-input__inner:focus {
          border-color: #DDDDDD;
        }

        .el-input-group__append {
          color: #3E97DF;
          background: #FFFFFF;
          padding-left: 0;
          padding-right: 10px;
          border-color: #DDDDDD;
        }
      }

      .hall-list {
        height: 425px;
        overflow-y: auto;
        margin-top: 30px;
      }
    }

    .map-content {
      display: inline-block;
      vertical-align: top;
      width: 746px;
      height: 540px;
      margin-left: 30px;
    }
  }

  .hall-item {
    text-align: left;

    &+.hall-item {
      margin-top: 30px;
    }

    .hall-name {
      font-size: 18px;
      font-weight: 500;
      color: #0D1C28;
      line-height: 22px;

      .hall-index-icon {
        display: inline-block;
        width: 20px;
        height: 20px;
        color: #FFFFFF;
        background: #3E97DF;
        border-radius: 50%;
        font-size: 12px;
        text-align: center;
        margin-right: 5px;
      }
    }

    .hall-item-detail {
      margin-top: 12px;
      font-size: 16px;
      font-weight: 400;
      color: #45484B;
      line-height: 22px;

      .hall-img {
        width: 14px;
        height: 14px;
        display: inline-block;
        margin-right: 6px;
        margin-top: 3px;
      }

      div {
        display: inline-block;
        width: calc(100% - 20px);
        vertical-align: top;
        text-align: left;
        white-space: normal;
      }
    }

    .hall-item-btn {
      margin-top: 16px;
      background: #3E97DF;
      height: 48px;
      line-height: 48px;
      width: 100%;
      color: #FFFFFF;
      font-size: 16px;
      font-weight: 500;
    }
  }
}
</style>
